import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "firebaseui/dist/firebaseui.css";
import SignIn from "../auth/SignIn";
import SignUp from "../auth/SignUp";

import CustomizedSnackbars from "../MaterialUI/CustomizedSnackbars";
// import SnapshotFirebaseAdvanced from "../../SnapshotFirebaseAdvanced";
// Sign up Modal imports:
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

import "../auth/SignIn.css";

function Login() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const inviteEmail = searchParams.get("email");
  const inviteOrgId = searchParams.get("orgId");

  // Modal States:
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (inviteEmail) {
      setOpen(true);
    }
  }, [inviteEmail]);

  //Closing the Modal after a successful sign up
  const handleSignUpSuccess = () => {
    window.location.href = "/home";
  };

  // Snackbar States
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("info");

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <div>
      <center>
        <div>
          <div>
            <h1 className="DStitleHome">Data Sculpture</h1>
          </div>
          <div>
            <p className="subTitleHome">Curation, analysis & presentation</p>
          </div>
          <SignIn />
          {/* <SnapshotFirebaseAdvanced /> */}
          <div className="sign-in-container">
            <h4>Don&apos;t Have an account yet?</h4>
            <Link className="button" onClick={handleOpen}>
              Sign Up
            </Link>
            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
              <Box className="modal">
                <SignUp
                  handleClose={handleClose}
                  isModal={true}
                  inviteEmail={inviteEmail}
                  inviteOrgId={inviteOrgId}
                  onSignUpSuccess={() => {
                    setSnackbarMessage("Account created successfully!");
                    setSnackbarSeverity("success");
                    setSnackbarOpen(true);
                    // Redirect to the home page
                    handleSignUpSuccess();
                  }}
                  onSignUpError={(errorMessage) => {
                    setSnackbarMessage(errorMessage);
                    setSnackbarSeverity("error");
                    setSnackbarOpen(true);
                  }}
                />
              </Box>
            </Modal>

            {/* Snackbar component */}
            <CustomizedSnackbars open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} handleClose={handleSnackbarClose} />
          </div>

          <br></br>
          <p className="footer">
            By signing in you agree to our{" "}
            <a href="/assets/docs/DataSculpturePolicy.html" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
            .
          </p>
        </div>
      </center>
    </div>
  );
}

export default Login;
